var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDebtors = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 17v-5h2v5h-2ZM15 20v-2h2v2h-2Z",
  fill: "#252834",
  fillOpacity: 0.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 16a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-2 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
  fill: "#252834",
  fillOpacity: 0.6
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.27 13.928C5.54 14.133 2.9 15.412 2.9 16v1.1h5.175c.091.663.263 1.3.507 1.9H1v-3c0-2.66 5.33-4 8-4h.07a7.95 7.95 0 0 0-.8 1.928Zm4.324-5.169a8.03 8.03 0 0 0-2.77 2.156A3.999 3.999 0 0 1 5 7c0-2.21 1.79-4 4-4a3.999 3.999 0 0 1 3.594 5.76ZM11.1 7a2.1 2.1 0 1 0-4.2 0 2.1 2.1 0 0 0 4.2 0Z",
  fill: "#252834",
  fillOpacity: 0.6
})));
export default SvgDebtors;